<template>
    <div class="auth-wrapper auth-v2 bg-white">
        <b-row class="auth-inner m-0">
            <div class="w-100 d-flex flex-column justify-content-between">
                <HeaderBar/>
                <div class="px-1  bg-white flex-fill">
                    <div class="d-flex flex-column  mt-4 ">
                        <div class="title d-flex justify-content-center align-items-center mt-2">
                           Mis Fincas
                        </div> 
                        <AddButton preTitle="Agregar Finca" goTo="basic-createFarm"/>
                        <div class="mb-2 mt-2   ">
                            <!-- Edit Modal -->
                            <b-card v-if="!modalShow" no-body class="overflow-hidden" v-for="data in farms"
                                style="max-width: 540px;">
                                <b-row no-gutters>
                                    <b-col >
                                        <b-card 
                                        :title="data.name"
                                        :img-src="data.image_url">
                                            <b-card-text>
                                                <p><strong>CVO:</strong> {{ data.cvo }}</p>
                                                <p><strong>HA de Pastos:</strong> {{ data.pasture_ha }}</p>
                                                <p><strong>Número de Apartos:</strong> {{ data.aparts_ha }}</p>
                                                <p><strong>Sistema:</strong> {{ data.system }}</p>
                                                <p><strong>Provincia:</strong> {{ data.province }}</p>
                                                <p><strong>Cantón:</strong> {{ data.canton }}</p>
                                                <p><strong>Distrito:</strong> {{ data.district }}</p>
                                            </b-card-text>
                                            <b-button
                                                text
                                                variant="primary"
                                                @click="editBtn(data.id)"
                                            >
                                                Editar
                                            </b-button>
                                        </b-card>
                                    </b-col>
                                </b-row>
                                
                            </b-card>
                            <div class="preTitle modalRad">
                    
                          <!-- Delete Modal -->
                                <b-modal  centered v-model="modalShow" hide-footer hide-header>

                                    <div class="d-flex align-items-center justify-content-center subTitle pt-3"> Finca 1. El
                                        cenizaro</div>
                                    <div class="d-flex align-items-center justify-content-center subTitle">Editar</div>

                                    <validation-observer ref="FarmView" #default="{ invalid }">
                                        <div class="">
                                            <b-form class="mt-2">
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label>HA de Pastos:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="HA"
                                                                vid="HA" rules="required">
                                                                <b-form-input id="HA" v-model="ha" name="HA"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label>Número de Apartos:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Apartos"
                                                                vid="Apartos" rules="required">
                                                                <b-form-input id="Apartos" v-model="apartos"
                                                                    name="Apartos"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label> Sistema:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Apartos"
                                                                vid="Apartos" rules="required">
                                                                <b-form-input id="Apartos" v-model="username"
                                                                    name="Apartos"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label> Provincia:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Apartos"
                                                                vid="Apartos" rules="required">
                                                                <b-form-input id="Apartos" v-model="provincia"
                                                                    name="Apartos"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label>Cantón:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Cantón"
                                                                vid="Cantón" rules="required">
                                                                <b-form-input id="Cantón" v-model="cantón"
                                                                    name="Cantón"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center pb-2">
                                                        <label>Distrito:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Distrito"
                                                                vid="Distrito" rules="required">
                                                                <b-form-input id="Distrito" v-model="distrito"
                                                                    name="Distrito"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                            </b-form>
                                        </div>
                                    </validation-observer>


                                </b-modal>
                                   <b-modal size="sm" centered v-model="modalTrashShow" hide-footer hide-header>
                                   <div class="d-flex  align-items-end justify-content-end"> <feather-icon  @click="modalTrashShow = !modalTrashShow" icon="XIcon" size="20" /></div>
                                   <div class="d-flex flex-column align-items-center justify-content-center">  
                                        <span class="deleteModal mt-3"> ¿Desea eliminar? </span>
                                        <b-button class="deleteButton mt-2 mb-2">Eliminar</b-button>
                                    </div>
                                   </b-modal>
                            </div>

                        </div>
                       
                    </div> 
                </div>
                <ControlMenu />
            </div>
        </b-row>

    </div>
</template>

<script>
import {
    BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormGroup, BFormInput, BInputGroup, BImg, BCardTitle,BCardImg, BCardText,
} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import AddButton from '@/components/AddButton.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    components: {
        BRow,
        BImg,
        BCol,
        BLink,
        BButton,
        BForm,
        BCardText,
        BCardTitle,
        BFormGroup,
        BFormInput,
        BInputGroup,
        ControlMenu,
        HeaderBar,
        AddButton,
        BCardBody,
        BCardImg,
        BCard,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            status: '',
            farms: [],
            modalShow: false,
            modalTrashShow:false,
            username: '',
            distrito:'',
            ha:'',
            cantón:'',
            provincia:'',
            sistema:'',
            apartos:'',
            cvo:''
            
        }
    },
    methods: {
        async s(config){
            fetch(this.$apiUrl+"list/FarmsViews?recperpage=all", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.FarmsViews);
                this.farms = result.FarmsViews.map(item => {return {id:item.id,name:item.name,cvo:item.cvo,pasture_ha:item.pasture_ha,aparts_ha:item.aparts_ha,system:item.system, province:item.province,canton:item.canton,district:item.district,image_url:item.image_url }});
                console.log(this.farms);
            })
        },
        editBtn(value){
            this.$router.push('/basicHome/farm/editfarm/'+ value );
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.s(config);
    }
}
</script>

<style lang="scss">
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.subTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #5E5873;
}


.dataLog {
    font-weight: 500;
    font-size: medium;
    color: #5E8F23;
}

.deleteModal{
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
}
 .deleteButton{
    border-color: #EA5455 !important;
    padding: 10px 22px;
    box-shadow: inset 0px -3px 0px rgba(255, 0, 0, 0.2) !important;
    border-radius: 49px;
    width: 107px;
    height: 37px;
    background-color: #EA5455 !important;
    mix-blend-mode: normal;
    box-shadow: inset 0px -3px 0px rgba(0, 0, 0, 0.2);

}
#__BVID__40___BV_modal_content_{
    border-radius: 43px;
}
#__BVID__59___BV_modal_content_{
    border-radius: 43px;
}
#__BVID__41___BV_modal_content_{
    border-radius: 25px;
}
#__BVID__60___BV_modal_content_{
    border-radius: 25px;
}

.model-content {
    border-radius:30px;
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>
